import { createContext, useContext } from "react";
import type { UserPoolScope } from "@common/domain/auth";

export class UserInfo {
  userId: string;
  accessToken: string;
  email: string;
  name?: string;
  groups: string[];
  userPool: UserPoolScope;
  isInCall: boolean;
  /** Raw Cognito `custom:module_order` claim (CSV like "3,1,2"); undefined when unset. */
  moduleOrder?: string;

  constructor(data: {
    userId: string;
    accessToken: string;
    email: string;
    name?: string;
    groups: string[];
    userPool: UserPoolScope;
    isInCall: boolean;
    moduleOrder?: string;
  }) {
    this.userId = data.userId;
    this.accessToken = data.accessToken;
    this.email = data.email;
    this.name = data.name;
    this.groups = data.groups;
    this.userPool = data.userPool;
    this.isInCall = data.isInCall;
    this.moduleOrder = data.moduleOrder;
  }

  get displayName(): string {
    return this.name || this.email || 'User';
  }

  get initial(): string {
    return (this.name || this.email || 'U').charAt(0).toUpperCase();
  }
}

interface UserInfoContextType {
  userInfo: UserInfo | undefined;
  updateUserInfo: (newValue: any) => void;
}

const UserInfoContext = createContext<UserInfoContextType | undefined>(
  undefined
);

export function useUserInfoContext() {
  const context = useContext(UserInfoContext);
  if (context === undefined) {
    throw new Error();
  }
  return context;
}

export default UserInfoContext;
